import {MasterController} from './master_controller'

export default class extends MasterController {
    static targets = ['code', 'name', 'modal', 'iframe']

    getParams() {
        if (this.hasStoreCodeTarget && this.storeCodeTarget.value) {
            return `&market_single_form[no_header]=true&market_single_form[code]=${this.codeTarget.value}&market_single_form[store_code]=${this.storeCodeTarget.value}`
        } else {
            return `&market_single_form[no_header]=true&market_single_form[code]=${this.codeTarget.value}`
        }
    }

    searchCode(e) {
        super._searchCode(e, 'markets')
    }

}
